import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable()
export class ObervableService {

	constructor() {
		// THIS IS INTENTIONAL
	}

	// FOR PAGINATOR REFRESHING.
	public refreshPagination = new BehaviorSubject<boolean>(null);
	paginationBehavior = value => {
		this.refreshPagination.next(value);
	}

	// FOR LOADER
	public showLoader = new BehaviorSubject<boolean>(null);
	changeLoaderValue = value => {
		this.showLoader.next(value);
	}
}
